import { Component } from 'react';
import {connect} from 'react-redux';
import {Container} from 'react-bootstrap';
import PageTitle from '../../../common/page-title/index';
import {getEmailLogs, getEmailBody} from '../../../../actions/logs';
import withPaginatedFilter from '../../../common/withPaginatedFilter';
import NotificationFilter from '../notification-filter';
import EmailNotificationsTable from './email-notification-table';
import LogBody from '../log-body';
import EmailPreview from './email-preview';

class EmailLogs extends Component {
  state = {
    preview: undefined
  };

  formatEmail = email => ({
    id: email.id,
    email: this.createBody(email)
  });

  createBody = email => (
    <LogBody.email
      to={email.attributes.rcpt}
      subject={email.attributes.subject}
      sent={email.attributes['sent-date']}
    />
  );

  showEmailPreview = () => {
    const {loadingBody: loading} = this.props;
    const {preview} = this.state;

    return preview !== undefined && !loading;
  };

  onPreview = (id) => {
    const {dispatch} = this.props;
    dispatch(getEmailBody(id)).then(() => this.setState(() => ({
      preview: id,
    })));
  };

  onClosePreview = () => {
    this.setState(() => ({
      preview: undefined,
    }));
  };

  render() {
    const {
      emails, paging, pageNumber, loadingBody, emailBody, doSearch, query, handleChange, handleClear, handleSearch, handlePageChange
    } = this.props;

    const data = emails.map(this.formatEmail);

    return (
      <Container fluid className="notifications">
        <PageTitle>Email notification logs</PageTitle>

        <NotificationFilter
          onChange={handleChange}
          onClear={handleClear}
          onSearch={handleSearch}
          doSearch={doSearch}
          searchValue={query}
        />

        <EmailNotificationsTable
          notifications={data}
          currentPage={pageNumber}
          onPageChange={handlePageChange}
          paging={paging}
          onPreview={this.onPreview}
          searchValue={query}
          loadingEmail={loadingBody}
        />

        <EmailPreview
          onClose={this.onClosePreview}
          show={this.showEmailPreview()}
        >
          {emailBody}
        </EmailPreview>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  emails: state.notificationLog.emailList,
  emailBody: state.notificationLog.emailBody,
  paging: state.notificationLog.paging,
  fetched: state.notificationLog.fetched,
  fetching: state.notificationLog.fetching,
  loadingBody: state.notificationLog.bodyFetching && !state.notificationLog.bodyFetched,
});

export default connect(mapStateToProps)(withPaginatedFilter(EmailLogs, getEmailLogs));
